import React from 'react';
import { Link } from 'react-scroll';
import { Navbar, Nav } from 'react-bootstrap';
import logo from '../logo.png';

const Navigation = () => {
  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
      <Navbar.Brand href="#home">
        <img
          src={logo}
          width="50"
          height="50"
          className="d-inline-block align-top"
          alt="SigisBell Logo"
        />
        {' SigisBell'}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link as={Link} to="home" spy={true} smooth={true} offset={-70} duration={500}>Home</Nav.Link>
          <Nav.Link as={Link} to="services" spy={true} smooth={true} offset={-70} duration={500}>Services</Nav.Link>
          <Nav.Link as={Link} to="about" spy={true} smooth={true} offset={-70} duration={500}>About</Nav.Link>
          <Nav.Link as={Link} to="contact" spy={true} smooth={true} offset={-70} duration={500}>Contact</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Navigation;